<template>
	<div class="">
		<!-- 网关选择模板添加终端 -->
				
		<el-form class="chooseModel">
	        <p class="danger ml20">如果网关已有终端设备，选择模板进行添加终端会清空原有终端。</p>
			<el-form-item label="模板：" :label-width="formLabelWidth">
				<el-radio-group v-model="template_id">
			      <el-radio v-for="(model,index) in modelList" :label="model.id" :key="index">{{model.template_name}}</el-radio>
			    </el-radio-group>
			</el-form-item>
			<br />
			<el-form-item class="text-right">
				<el-button @click="hideModel()">取 消</el-button>
				<el-button type="primary" @click="confirmChoose()">确 定</el-button>
			</el-form-item>
		</el-form>

	</div>
</template>

<script>
	export default {
		mounted() {
			this.getModels();
		},
		props:['device_id'],
    	data(){
    		return{
				formLabelWidth: "90px",
				mydevice_id: this.device_id || 0,
				modelList: [],
				template_id: 0
				
    		}
		},		
    	methods:{
			//获取终端模板
    		getModels(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/TemplateShow",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
						this.modelList = res.data.data || [];											
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg,2000);
		        	}
		  		});
			},
			confirmChoose(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id: this.mydevice_id,
					template_id: this.template_id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/TemplateAddMountDetail",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
						this.$message.success(res.data.msg,2000);
						this.$emit('chooseByValue', false)
						
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg,2000);
		        	}
		  		});
			},			
			// 子传父通讯
			hideModel(){
				this.$emit('chooseByValue', false)
			},
    		
    	
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/chooseModel.vue